module.exports = __webpack_public_path__ + "media/Loops 110 Strings 2.b00a3599.wav";